<template>
  <div class="col-span-12 xl:col-span-8"><slot /></div>
</template>
